import { useEffect, useState } from "react";
import type { SuccessFetch } from "../../../../../../types";
import { useApi } from "../../../../../../utils";
import { DataType } from "../../types/DataType";

interface FilteredParams {
  page?: number;
  keyword?: string;
  limit?: number;
  sort?: string;
}

export function useList({ page, keyword, limit, sort }: FilteredParams) {
  // Vars
  const defaultValue = {
    items: [],
    pagination_data: {
      page: 0,
      pages: 0,
      size: 0,
      total: 0,
    },
  };

  // hook
  const api = useApi();
  const [data, setData] = useState<DataType>(defaultValue);
  const [isLoading, setLoading] = useState(true);

  const params: { [key: string]: number | string | undefined } = {};
  if (page) params.page = page;
  if (keyword) params.keyword = keyword;
  if (limit) params.limit = limit;
  if (sort) params.sort = sort;

  const fetchUrl = () => api.get("/groupasset/all", { params });

  const fetchData = () => {
    setLoading(true);

    fetchUrl()
      .then(
        (
          res: SuccessFetch<{
            payload: DataType;
          }>
        ) => {
          setData(res.data.payload);
        }
      )
      .catch(() => {
        setData(defaultValue);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const refetch = () => fetchData();

  useEffect(() => {
    fetchData();

    return () => {
      setData(defaultValue);
      setLoading(true);
    };

    // eslint-disable-next-line
  }, [page, keyword, limit, sort]);

  return { data, isLoading, refetch };
}

export function useCode() {
  const api = useApi();
  const [dataCode, setDataCode] = useState<{ code: string } | null>(null);

  useEffect(() => {
    const fetchData = () => api.get("/groupasset/gencode");

    fetchData()
      .then(
        (
          res: SuccessFetch<{
            payload: { code: string };
          }>
        ) => {
          setDataCode(res.data.payload);
        }
      )
      .catch(() => {
        setDataCode(null);
      })
      .finally(() => {});

    return () => {
      setDataCode(dataCode);
    };

    // eslint-disable-next-line
  }, []);

  return { dataCode };
}
